// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-2",
    "aws_cognito_identity_pool_id": "us-west-2:5b0e12e2-72fa-483e-acac-e260c9e50c35",
    "aws_cognito_region": "us-west-2",
    "aws_user_pools_id": "us-west-2_8MSANBMqN",
    "aws_user_pools_web_client_id": "2hafi7kto8l5obe0hlj2oakenh",
    "oauth": {}
};


export default awsmobile;
